import React, { useState } from "react";

import { Spinner } from "react-bootstrap";
import Card from "react-bootstrap/Card";

import { PALETTE } from "../../common/ThemeConstants";

export default function CardSubscription({
  subscription,
  color = PALETTE.LIGHTGRAY,
  cover = "Undefined",
  width = 200,
  to = "",
  onSubmit = (idSubscription) => {},
}) {
  const [buttonContent, setButtonContent] = useState("CHECKOUT");
  const title =
    subscription.months > 1
      ? `${subscription.months} mesi`
      : `${subscription.months} mese`;

  const onClick = () => {
    setButtonContent(
      <Spinner className="px-2 py-2" size="sm" animation="border" />
    );
    const terminated = onSubmit(subscription.id);
    if (terminated) {
      setButtonContent("CHECKOUT");
    }
  };
  return (
    <Card
      style={{
        width: width,
        maxWidth: "100%",
        color: color,
        borderRadius: "20px",
        backgroundColor: PALETTE.BLACK,
        cursor: "pointer",
      }}
      className="m-auto text-center workout-card"
      onClick={onClick}
    >
      <Card.Header>
        <Card.Title style={{ paddingTop: 4, color: PALETTE.WHITE }}>
          {title}
        </Card.Title>
      </Card.Header>

      <Card.Body>
        <Card.Img
          src={subscription.cover}
          alt={subscription.name}
          style={{
            objectFit: "cover",
            borderRadius: "20px",
          }}
        />
        <Card.Text>
          <span style={{ fontSize: "2rem" }}>
            {(subscription.price / subscription.months).toFixed(2)}
          </span>{" "}
          € / Mese
        </Card.Text>
      </Card.Body>
      <Card.Footer
        style={{
          backgroundColor: PALETTE.DARK,
          color: PALETTE.WHITE,
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
      >
        <span>{buttonContent}</span>
      </Card.Footer>
    </Card>
  );
}
